import type { Cart } from '@/types/booking';

/**
 * Compact signature of everything on the cart that can change the membership
 * discount or the total. The guest validation is deduped per identity, so
 * without this a cart edit (e.g. removing a promo, which un-blocks the
 * membership discount) would never re-validate (SQR-15069).
 */
export const buildCartRevision = (cart?: Cart | null): string =>
  JSON.stringify([
    cart?.id ?? null,
    cart?.promoCode ?? cart?.promo?.id ?? null,
    cart?.giftCardCode ?? null,
    // Card payments never affect validation (the API rejects them when echoed)
    cart?.payments
      ?.filter((payment) => payment.type === 'gift_card')
      .map((payment) => [payment.type, payment.amount]) ?? [],
    cart?.items?.map((item) => [
      item.barberId ?? null,
      item.dateTime ?? null,
      item.tipAmount ?? 0,
      item.services?.map((service) => service.id) ?? [],
    ]) ?? [],
  ]);
